export default "__VITE_ASSET__244fa85a__"